module.exports = __webpack_public_path__ + "producr-dried fresh-grass-main-thumb-03.jpg?1d81a326812e2182d5ecfbff6c21429d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-main-thumb-03.jpg
// module id = 58
// module chunks = 0